export default {
    currentUser: null,
    userProfile: {},
    boards: [],
    tasks: {},
    currentBoard: {},
    tasksBinded: false
};
